export default "__VITE_ASSET__CpYjOujz__"